<template>
  <div class="info"><i class="fa fa-info-circle"></i>
    <span class="infotext">{{text}}</span>
  </div>
</template>

<script>
export default {
    name: 'Info',
    props: {
        text: {
            type: String,
        }
    }
}
</script>

<style scoped>
.info {
  position: relative;
  display: inline-block;
}

.info .infotext {
  visibility: hidden;
  width: auto;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.info:hover .infotext {
  visibility: visible;
}
</style>